import { render, staticRenderFns } from "./ranking-tab.vue?vue&type=template&id=1cb52e2a&scoped=true"
import script from "./ranking-tab.vue?vue&type=script&lang=js"
export * from "./ranking-tab.vue?vue&type=script&lang=js"
import style0 from "./ranking-tab.vue?vue&type=style&index=0&id=1cb52e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb52e2a",
  null
  
)

export default component.exports